<template>
    <div class="panel-content-sidebar">
        <div class="p-3">
            <div class="legends">
                <span v-if="!hasLegendItems">
                    {{ $t('stylesUndefined') }}
                </span>
                <div v-for="layer in legendData" :key="layer.id">
                    <span
                        v-if="layer.isImageObject || layer.geometryType"
                        :ref="`layer_title_${layer.id}`"
                        class="font-weight-bold"
                    >
                        {{ layer.title }}
                    </span>
                    <style-custom-css
                        v-if="layer.isCustomCssObject && layer.geometryType"
                        :geometryType="layer.geometryType.split('')"
                        :customStylingOptions="
                            layer.styles[0].customStylingOptions
                        "
                        :hideFill="layer.hideFill"
                    />
                    <style-css
                        v-if="layer.isCssObject && layer.geometryType"
                        :layer="layer"
                        :hideFill="layer.hideFill"
                    />
                    <style-image
                        v-if="layer.isImageObject"
                        :layer="layer"
                        @imgNotFound="$_onImgNotFound"
                    />
                    <!-- OGCT style, disabled for now-->
                    <style-ogct
                        v-if="false && layer.styleServiceUrl"
                        :styleServiceUrl="layer.styleServiceUrl"
                        :styleId="layer.styles[0].name"
                    >
                    </style-ogct>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import StyleCustomCss from './StyleCustomCss.vue';
    import StyleCss from './StyleCss.vue';
    import StyleImage from './StyleImage.vue';
    import StyleOgct from './StyleOgct.vue';

    export default {
        name: 'legend-content',

        components: {
            'style-custom-css': StyleCustomCss,
            'style-css': StyleCss,
            'style-image': StyleImage,
            'style-ogct': StyleOgct
        },

        props: {
           legendData: { type: Array, required: true }
        },

        computed: {
            hasLegendItems() {
                return this.legendData.length > 0;
            },
        },

        methods: {
            /**
             * Hide title if an error occurs when loading the image
             * @param id int - id of layer
             */
            $_onImgNotFound(id) {
                const span = this.$refs[`layer_title_${id}`];
                if (span && span.length === 1) {
                    span[0].style.display = 'none';
                }
            }
        }
    };
</script>

<style scoped lang="scss">
.panel-content-sidebar {
    flex: 1;
    display: flex !important;
    flex-direction: column;
    overflow: auto;
}
</style>
